import Orchestrator from "@bookingcom/web-page-orchestrator";
let initialised = false;
export const getIsOrchestratorInitialised = () => initialised;
export const setIsOrchestratorInitialised = (val) => {
    initialised = val;
};
export const orchestratorInitialiser = () => {
    if (process.env.BUILD_TARGET !== "client")
        return;
    if (typeof window === "undefined")
        return;
    const orchestrator = window.orchestrator || new Orchestrator();
    window.orchestrator = orchestrator;
    setIsOrchestratorInitialised(true);
};
